module.exports = __webpack_public_path__ + "fonts/Bluu-Next-Cyrillic-2.adbefbe0.otf";